/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InvoiceUserFlagRead } from '../models/InvoiceUserFlagRead';
import type { TaxCodeRead } from '../models/TaxCodeRead';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ReferenceDataService {

    /**
     * Get All Tax Codes
     * @param opco
     * @param showAll
     * @returns TaxCodeRead Successful Response
     * @throws ApiError
     */
    public static getAllTaxCodesDataTaxCodesAllGet(
        opco: string,
        showAll: boolean = true,
    ): CancelablePromise<Array<TaxCodeRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/data/tax_codes/all',
            query: {
                'show_all': showAll,
                'opco': opco,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Ui Invoice User Flags
     * @returns InvoiceUserFlagRead Successful Response
     * @throws ApiError
     */
    public static getUiInvoiceUserFlagsDataUiInvoiceUserFlagsGet(): CancelablePromise<Array<InvoiceUserFlagRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/data/ui_invoice_user_flags',
        });
    }

}
